module.exports = __webpack_public_path__ + "img/carrier.6c1dc0ec.svg";